import { useSyncExternalStore } from "react";

const subs = new Set<() => void>();
window.addEventListener("popstate", () => subs.forEach((f) => f()));
export function navigate(to: string, replace = false) {
  if (to === location.pathname + location.search) return;
  if (replace) history.replaceState(null, "", to); else history.pushState(null, "", to);
  subs.forEach((f) => f());
}
export function useLocation(): { path: string; search: URLSearchParams } {
  const href = useSyncExternalStore((cb) => { subs.add(cb); return () => subs.delete(cb); }, () => location.pathname + location.search);
  const u = new URL(href, location.origin);
  return { path: u.pathname, search: u.searchParams };
}
export function match(pattern: string, path: string): Record<string, string> | null {
  const a = pattern.split("/").filter(Boolean), b = path.split("/").filter(Boolean);
  if (a.length !== b.length) return null;
  const out: Record<string, string> = {};
  for (let i = 0; i < a.length; i++) {
    if (a[i]!.startsWith(":")) out[a[i]!.slice(1)] = decodeURIComponent(b[i]!);
    else if (a[i] !== b[i]) return null;
  }
  return out;
}
